// Angular
import { Component } from '@angular/core';

// Formly
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'formly-field-kendo-multiselect',
    templateUrl: './kendo-multiselect.type.component.html',
})
export class FormlyFieldKendoMultiSelect extends FieldType {

}
